<template>
  <v-card-text>
    <v-layout>
      <v-flex xs9>
        <v-layout v-for="(model, index) in valuesModels" :key="index">
          <v-flex xs10>
            <v-text-field
              type="text"
              label="Wprowadź wartość"
              :value="model.value"
              @change="updateValue(index, $event)"/>
          </v-flex>
          <v-flex xs1>
            <v-btn fab small dark color="warning" @click="remove(index)">
              <v-icon>delete_forever</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs1>
        <v-btn fab small color="primary" @click="appendValue">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>
<script>
export default {
  name: "radio-options",
  props: [ 'id', 'values' ],
  data() {
    return {
      valuesModels: this.values || [],
    }
  },
  methods: {
    update() {
      let payload = {
        id: this.id,
        values: this.valuesModels
      }
      this.$emit('update', payload)
    },
    remove(index) {
      this.valuesModels.splice(index, 1)
      this.update()
    },
    appendValue() {
      this.valuesModels.push({ value: "", is_default: 0 })
    },
    updateValue(index, value) {
      this.valuesModels[index].value = value
      this.update()
    }
  },

}
</script>
<style>
</style>
